
// Update app function
export function updateApp() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            if (registration.waiting) {
                registration.waiting.postMessage('skipWaiting');
            }
        });
    }
    window.location.reload();
}

// Checking for updates
export function registerServiceWorker(showUpdateNotificationCb) {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .register('./service-worker.js')
            .then((registration) => {
                // Check for updates every 60min
                setInterval(() => {
                    registration.update();
                }, 60 * 60 * 1000);

                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;

                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {

                            console.log('Update available');
                            if (showUpdateNotificationCb !== undefined) {
                                showUpdateNotificationCb();
                            }
                        }
                    });
                });
            });
    }
}
